import { useTranslation } from "react-i18next";
import ModernProductSelectorV2 from "./ModernProductSelectorV2";

/** Shared dialog for the product picker used by service consumption's manual search. */
export default function ModernProductSelectorDialog({ open, onClose, multiple = false, ...props }) {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <ModernProductSelectorV2 {...props} open multiple={multiple} onClose={onClose}
      showHeader={false} pmdialogDense pmdialogSize="7xl"
      pmdialogTitle={t(multiple ? "product.selector.dialog_title_multiple" : "product.selector.dialog_title")}
      showQuantityInput={multiple} />
  );
}
